import { useMutation } from 'react-query';
import updateCalendarEvent from '../../../requests/updateCalendarEvent';
import { createOptions } from './utls';

const useEditTaskMutation = (options) => {
  return useMutation(({ values }) => {
    const { taskId, ...restValues } = values;

    return updateCalendarEvent(taskId, restValues, 'Error');
  }, createOptions(options));
};

export default useEditTaskMutation;
